import { AxiosClient } from "../../axiosClient";
import { LoginRequestDTO } from "../../dtos/login";
import { type IUserApi } from "./IUserApi";

export class UserApi implements IUserApi {

    constructor(readonly axiosClient: AxiosClient) {
    }

    public async login(dto: LoginRequestDTO): Promise<void> {
        const response = await this.axiosClient.post('/auth/login', dto);

        this.axiosClient.setAuthToken(response.data.access_token);
    }

    public async logout(): Promise<void> {
        this.axiosClient.unsetAuthToken();
    }

    public async deleteAccount(): Promise<void> {
        this.axiosClient.post('/user/delete', {});

        this.axiosClient.unsetAuthToken();
    }
}